(()=>{'use strict';
const IMAGES={
  'Stone Gray':{src:'https://cdn.shopify.com/s/files/1/1014/5638/0230/files/little-roar-grey-render_77798e34-21b5-4f46-bc4b-77157ed325cf.png?v=1786093534',alt:'Grey Little Roar'},
  'Midnight Black':{src:'https://cdn.shopify.com/s/files/1/1014/5638/0230/files/little-roar-black-render_6b676f37-c410-4a7b-9e62-7c2f20ce7fb0.png?v=1786093510',alt:'Black Little Roar'},
  'Mint Green':{src:'https://cdn.shopify.com/s/files/1/1014/5638/0230/files/little-roar-green-render_b3816537-10e3-42ae-8dc6-d4240be2664a.png?v=1786093492',alt:'Green Little Roar'},
  'Grape Purple':{src:'https://cdn.shopify.com/s/files/1/1014/5638/0230/files/little-roar-purple-render_d1a79af0-04d3-4dbb-8a54-bf585d13a378.png?v=1786093476',alt:'Purple Little Roar'},
  'Fossil Ivory':{src:'https://cdn.shopify.com/s/files/1/1014/5638/0230/files/little-roar-white-render_25a338fa-a7a4-438b-beac-11e1bf1e6fd0.png?v=1786093459',alt:'White Little Roar'}
};
const ensureGlowStyles=()=>{
  if(document.getElementById('lr-glow-oos-v14-styles'))return;
  const style=document.createElement('style');
  style.id='lr-glow-oos-v14-styles';
  style.textContent='.little-roar-page .lr9-colour.lr9-glow-oos{cursor:not-allowed;opacity:.72}.little-roar-page .lr9-colour.lr9-glow-oos:hover{transform:none}.little-roar-page .lr9-colour.lr9-glow-oos img{filter:saturate(.7);opacity:.9}.little-roar-page .lr9-glow-oos-badge{position:absolute;left:50%;bottom:6px;transform:translateX(-50%);z-index:2;padding:4px 6px;border-radius:999px;background:rgba(18,63,57,.92);color:#fff;font-size:.44rem;font-style:normal;font-weight:1000;letter-spacing:.04em;line-height:1;white-space:nowrap}@media(min-width:720px){.little-roar-page .lr9-colours.lr9-colours--with-glow{grid-template-columns:repeat(6,minmax(0,1fr))}}';
  document.head.append(style);
};
const addGlow=root=>{
  if(!root?.querySelectorAll)return;
  const source=root.querySelector?.('.lr-gift-visual img')||document.querySelector('.lr-gift-visual img');
  if(!source?.src)return;
  root.querySelectorAll('.lr9-colours').forEach(grid=>{
    grid.classList.add('lr9-colours--with-glow');
    if(grid.querySelector('[data-lr9-glow-oos]'))return;
    const btn=document.createElement('button');
    btn.type='button';
    btn.className='lr9-colour lr9-glow-oos';
    btn.disabled=true;
    btn.setAttribute('aria-disabled','true');
    btn.setAttribute('aria-label','Glow — out of stock');
    btn.setAttribute('data-lr9-glow-oos','');
    const frame=document.createElement('span');
    const img=source.cloneNode(false);
    img.removeAttribute('srcset');
    img.alt='Glow Little Roar';
    img.width=220;
    img.height=180;
    img.loading='lazy';
    const badge=document.createElement('em');
    badge.className='lr9-glow-oos-badge';
    badge.textContent='OUT OF STOCK';
    const name=document.createElement('b');
    name.textContent='Glow';
    frame.append(img,badge);
    btn.append(frame,name);
    grid.append(btn);
  });
};
const apply=root=>{
  if(!root?.querySelectorAll)return;
  root.querySelectorAll('.lr9-colour[data-lr9-colour]').forEach(btn=>{
    const media=IMAGES[btn.dataset.lr9Colour],img=btn.querySelector('img');
    if(!media||!img)return;
    if(img.src!==media.src)img.src=media.src;
    img.removeAttribute('srcset');
    img.alt=media.alt;
  });
  addGlow(root);
};
let queued=false;
const schedule=()=>{if(queued)return;queued=true;queueMicrotask(()=>{queued=false;apply(document);});};
const start=()=>{
  ensureGlowStyles();
  apply(document);
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',e=>apply(e.target));
};
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
})();
